import { Button, Form, FormInstance, Select } from 'antd';
import ChevronDownIcon from 'assets/icons/chevron-down.svg';
import { setVisibleCU03603 } from 'presentation/redux/features/CU/CU03603Slice';
import { showConfirm } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import getMessage, { MESSAGE_VALIDATION } from 'utilities/constants/MESSAGE';
import { PLACEHOLDER } from 'utilities/constants/PLACEHOLDER';
import { commonHelpers } from 'utilities/helpers';
import { SellingPrice } from '../models/Property';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';

export const DesiredSellingPrice = (props: {
    data?: SellingPrice;
    isDisabled: boolean;
    defaultValue?: number;
    form: FormInstance<any>;
    auctionId?: string;
    onSubmit: (statusProcessWf?: string) => void | Promise<void>;
}) => {
    const [upperPrices, setUpperPrices] = useState<{ value: number; name: string }[]>([]);
    const [lowerPrices, setLowerPrices] = useState<{ value: number; name: string }[]>([]);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (props.auctionId) {
            generatePriceChangeOption();
        } else {
            generateLoanOption();
        }
    }, [props.data]);

    const submit = async (statusProcessWf?: string) => {
        await props.onSubmit(statusProcessWf);
    };
    const generateLoanOption = () => {
        const lowerPriceOption: { value: number; name: string }[] = [];
        const upperPriceOption: { value: number; name: string }[] = [];
        const marketPrice = commonHelpers.roundTenThousandYen(props.data?.marketPrice);
        const lowerLimitMargin = props.data?.lowerLimitMargin ?? 0;
        const upperLimitMargin = props.data?.upperLimitMargin ?? 0;
        for (let i = marketPrice - upperLimitMargin; i <= marketPrice; i += 10) {
            lowerPriceOption.push({
                name: `${i.toLocaleString('en-US', {
                    maximumFractionDigits: 2,
                })} 万円`,
                value: i,
            });
        }

        for (let i = marketPrice - upperLimitMargin; i <= marketPrice + lowerLimitMargin; i += 10) {
            upperPriceOption.push({
                name: `${i.toLocaleString('en-US', {
                    maximumFractionDigits: 2,
                })} 万円`,
                value: i,
            });
        }
        setUpperPrices(upperPriceOption);
        setLowerPrices(lowerPriceOption);
    };

    const generatePriceChangeOption = () => {
        const lowerPriceOption: { value: number; name: string }[] = [];
        const upperPriceOption: { value: number; name: string }[] = [];
        const priceLowerLimit = commonHelpers.roundTenThousandYen(
            props.data?.askingSalePriceLowerLimit,
        );
        const priceUpperLimit = commonHelpers.roundTenThousandYen(
            props.data?.askingSalePriceUpperLimit,
        );
        const highestAuctionPrice = commonHelpers.roundTenThousandYen(
            props.data?.currentHighestAuctionPrice,
        );
        for (let i = highestAuctionPrice; i <= priceLowerLimit; i += 10) {
            lowerPriceOption.push({
                name: `${i.toLocaleString('en-US', {
                    maximumFractionDigits: 2,
                })} 万円`,
                value: i,
            });
        }

        for (let i = highestAuctionPrice; i <= priceUpperLimit; i += 10) {
            upperPriceOption.push({
                name: `${i.toLocaleString('en-US', {
                    maximumFractionDigits: 2,
                })} 万円`,
                value: i,
            });
        }
        setUpperPrices(upperPriceOption);
        setLowerPrices(lowerPriceOption);
    };

    const onClickNotListed = () => {
        dispatch(setVisibleCU03603());
    };

    const showPopupConfirm = () => {
        const confirmProps = commonHelpers.getConfirmProps(props.auctionId ? 'P022' : 'P009', {
            onOk: () => submit(),
        });
        dispatch(showConfirm(confirmProps));
    };
    const showPopupConfirm1 = () => {
        const confirmProps = commonHelpers.getConfirmProps('P010', {
            onOk: () => submit('DOING'),
        });
        dispatch(showConfirm(confirmProps));
    };

    const valiadteForm = () => {
        props?.form?.validateFields();
    };

    const handleClick = () => {
        navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_012_01}`);
    };

    return (
        <>
            <section style={{ width: '100%', marginBottom: 16 }} className="input-number-custom">
                <div style={{ marginBottom: 12 }} className="label-form">
                    希望下限価格<span style={{ color: '#EB5757' }}>*</span>
                </div>
                <Form.Item
                    style={{ margin: 0, padding: 0 }}
                    className="input-font-style label-form-style  "
                    name="askingSalePriceLowerLimit"
                    label={false}
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <Select
                        className="select-custom"
                        size="large"
                        suffixIcon={<img alt="" src={ChevronDownIcon} />}
                        placeholder={PLACEHOLDER.SELECT}
                        onChange={valiadteForm}
                    >
                        {lowerPrices.map((element) => (
                            <Select.Option
                                className="option-style"
                                key={element.value}
                                value={element.value}
                            >
                                {element.name}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
                <div style={{ marginBottom: 12, marginTop: 12 }} className="label-form">
                    希望上限価格<span style={{ color: '#EB5757' }}>*</span>
                </div>
                <Form.Item
                    style={{ margin: 0, padding: 0 }}
                    className="input-font-style label-form-style  "
                    name="askingSalePriceUpperLimit"
                    label={false}
                    rules={[
                        {
                            required: true,
                            message: getMessage('Sel_Required', '希望上限価格'),
                        },
                        ({ getFieldValue }) => ({
                            validator(_, value) {
                                if (!value) return Promise.resolve();
                                const askingSalePriceLowerLimit = getFieldValue(
                                    'askingSalePriceLowerLimit',
                                );
                                if (
                                    askingSalePriceLowerLimit &&
                                    askingSalePriceLowerLimit > value
                                ) {
                                    return Promise.reject(new Error(MESSAGE_VALIDATION.MESSAGE_1));
                                }
                                props.form.setFields([
                                    {
                                        name: ['askingSalePriceLowerLimit'],
                                        errors: [],
                                    },
                                ]);
                                return Promise.resolve();
                            },
                        }),
                    ]}
                >
                    <Select
                        className="select-custom"
                        size="large"
                        suffixIcon={<img alt="" src={ChevronDownIcon} />}
                        placeholder={PLACEHOLDER.SELECT}
                    >
                        {upperPrices.map((element) => (
                            <Select.Option
                                className="option-style"
                                key={element.value}
                                value={element.value}
                            >
                                {element.name}
                            </Select.Option>
                        ))}
                    </Select>
                </Form.Item>
            </section>
            {props.auctionId ? (
                <>
                    <section
                        style={{
                            width: '100%',
                            justifyContent: 'space-between',
                            display: 'flex',
                        }}
                    >
                        <Button
                            type="primary"
                            className="button-login-text"
                            style={{ width: '100%', height: 56 }}
                            disabled={props.isDisabled}
                            onClick={() => showPopupConfirm()}
                        >
                            変更する
                        </Button>
                    </section>
                </>
            ) : (
                <>
                    <section
                        style={{
                            width: '100%',
                            justifyContent: 'space-between',
                            display: 'flex',
                        }}
                    >
                        <Button
                            className="button-login-text button-red-custom"
                            style={{
                                width: 105,
                                height: 56,
                            }}
                            onClick={() => onClickNotListed()}
                        >
                            出品しない
                        </Button>
                        <Button
                            type="primary"
                            className="button-login-text"
                            style={{ width: 105, height: 56 }}
                            disabled={props.isDisabled}
                            onClick={() => showPopupConfirm()}
                        >
                            出品する
                        </Button>
                        <Button
                            className="button-login-text button-blue-custom"
                            style={{ width: 115, height: 56 }}
                            onClick={handleClick}
                        >
                            価格を相談する 
                        </Button>
                    </section>
                    <section
                        className="last-text button-style"
                        onClick={() => {
                            !props.isDisabled && showPopupConfirm1();
                        }}
                    >
                        下書きとして保存
                    </section>
                </>
            )}
        </>
    );
};
